module.exports = __webpack_public_path__ + "img/Imagen 2.a1ef56bf.jpg";